import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteEvent } from "../../services/eventService";

/**
 * Phase 37 — DELETE /api/events/:id mutation hook.
 *
 * Variable: bare UUID id (caller extracts baseId — RESEARCH Pitfall 2).
 * Soft-delete only (era-api sets `deletedAt`; no `db.delete(events)` anywhere — C-11).
 * EDM-05: delete operates whole-series for v1.11.
 *
 * On success: predicate-invalidates every cached `['events', ...]` query
 * (C-04 / INTG-05). No optimistic updates (D-03).
 * Toast / analytics are caller-side (onSuccess/onError overrides at form call site).
 */
export function useDeleteEvent() {
	const qc = useQueryClient();
	return useMutation<void, Error, string>({
		mutationFn: (id) => deleteEvent(id),
		onSuccess: () => {
			qc.invalidateQueries({ predicate: (q) => q.queryKey[0] === "events" });
		},
		retry: 0,
	});
}
